import { render } from "./AccordionFAQ.vue?vue&type=template&id=2e1a9186"
import script from "./AccordionFAQ.vue?vue&type=script&lang=js"
export * from "./AccordionFAQ.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__